<template>
  <Modal
    ref="createLabelsModal"
    :title="'Create New Labels'"
  >
    <!-- <template #modal-header /> -->
    <template #modal-main>
      <div class="settings container">
        <div class="row">
          <div class="col-12 settings__control-group">
            <label>Labels</label>
            <textarea
              ref="labels"
              v-model="labels"
              placeholder="Comma-separated values, eg. label1,label2,etc."
              rows="4"
              cols="50"
            />
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="footer">
        <button
          class="button modal-action-button"
          @click="createLabels"
        >
          Create Labels
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import Modal from '@/components/Modal.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'CreateLabelsModal',
  components: {
    Modal,
  },
  props: {
    datasetId: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  emits: ['label-created', 'closed'],
  data() {
    return {
      labels: '',
    };
  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  methods: {
    showModal() {
      this.$refs.createLabelsModal.showModal();
      this.$nextTick(() => {
        this.$refs.labels.focus();
      });
    },
    closeModal() {
      this.labels = '';
      this.$emit('closed');
      this.$refs.createLabelsModal.closeModal();
    },
    isJSON(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    parseInput(input) {
      if (this.isJSON(input)) {
        return JSON.parse(input);
      } else {
        return input; // or you can return input.split(",") if you expect comma-separated strings
      }
    },
    async createLabels() {
      let newLabels = [];
      if (this.labels && this.labels !== "") {
        newLabels = this.labels.split(",");
      }
      newLabels = newLabels.map((e) => e.trim()).filter((e) => e !== "");
      if (newLabels.length === 0) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: "Error: Missing valid labels",
          type: 'error',
          position: 'top',
        });
        return;
      }
      await this.dataConnect.addLabel2({
        dataset_id: this.datasetId,
        labels: newLabels.map((e) => ({ "name": e })),
      })
        .then((data) => {
          if (data.error) {
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Error: ${data.error.message}`,
              type: 'error',
              position: 'top',
            });
          } else {
            this.closeModal();
            this.$emit('label-created');
          }
        })
        .catch((error) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error: ${error}`,
            type: 'error',
            position: 'top',
          });
        });
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/css/themes/auzone/buttons.scss';
.settings {
  padding: 0.75rem 3rem;
}

@media (min-width: $breakpoint-sm) {
  .settings {
    min-width: 420px;
  }
}

.footer {
  display: flex;
  flex-direction: row;
  padding: 0.75rem 3rem;
  justify-content: flex-end;
}

</style>
